'use strict'

import angular from 'angular'
import HistoryController from './history.controller'

export default angular.module('updateServerApp.devices.history', [])
  .controller('DevicesHistoryController', HistoryController)
  .name



// WEBPACK FOOTER //
// ./client/app/devices/history/index.js